<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :min-width="size"
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
    :nudge-width="nudgeWidth"
  >
    <template #activator="{ on: menu }">
      <template v-if="icon">
        <v-tooltip top transition="fade-transition" v-if="tooltipText">
          <template #activator="{ on: tooltip }">
            <v-btn
              slot="activator"
              icon
              :small="small"
              :text="btnFlat"
              :depressed="btnDepressed"
              :color="btnColor"
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon :small="small" v-text="icon"></v-icon>
            </v-btn>
          </template>
          <span>{{ tooltipText }}</span>
        </v-tooltip>
        <v-btn icon :small="small" :text="btnFlat" :depressed="btnDepressed" v-on="{ ...menu }" v-else>
          <v-icon :small="small" v-text="icon"></v-icon>
        </v-btn>
      </template>
      <v-btn :text="btnFlat" :depressed="btnDepressed" :color="btnColor" v-on="{ ...menu }" v-else>
        {{ name }}
      </v-btn>
    </template>
    <VWidget :enable-footer-actions="!noActions" :foot-separator="!noSeparator" :content-class="contentClass">
      <template slot="title">
        <slot name="title">Title</slot>
      </template>
      <template slot="header-actions">
        <v-btn icon small @click="menu = false">
          <v-icon small>{{ $vuetify.icons.values.close }}</v-icon>
        </v-btn>
      </template>

      <template slot="alert">
        <slot name="alert" />
      </template>

      <template slot="content">
        <slot name="content"></slot>
      </template>

      <template slot="footer-actions">
        <slot name="footer-actions">
          <v-btn depressed color="default" @click="submit" v-if="submit">{{ $t('labels.save') }}</v-btn>
        </slot>
      </template>
    </VWidget>
  </v-menu>
</template>

<script>
import VWidget from './VWidget'

export default {
  name: 'VPopupWidget',
  components: {
    VWidget
  },
  props: {
    submit: { type: Function },
    setExpand: { type: Function, required: true },
    visible: { type: Boolean, default: true },
    name: { type: String, required: false, default: '' },
    icon: { type: String, required: false },
    nudgeWidth: { type: Number, default: 0 },
    top: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    contentClass: { type: String, default: 'white' },
    noActions: { type: Boolean, default: false },
    noSeparator: { type: Boolean, default: false },
    btnFlat: { type: Boolean, default: false },
    btnDepressed: { type: Boolean, default: false },
    btnColor: { type: String, default: 'default' },
    tooltipText: { type: String, required: false, default: '' }
  },
  computed: {
    size() {
      if (this.large) {
        return this.$app.opts.popupSizeLarge
      }
      if (this.medium) {
        return this.$app.opts.popupSizeMedium
      }
      if (this.small) {
        return this.$app.opts.popupSizeSmall
      }
      return this.$app.opts.popupSizeDefault
    },
    menu: {
      get() {
        return this.visible
      },
      set(v) {
        this.setExpand(v)
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "cancel": "@:labels.cancel",
    "save": "@:labels.save"
  },
  "fr": {
    "cancel": "@:labels.cancel",
    "save": "@:labels.save"
  }
}
</i18n>
